import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { StoryletRoot } from 'components/StoryletRoot';

import SecondChanceComponent from 'components/SecondChance/SecondChanceComponent';
import { IAppState } from 'types/app';

type Props = ReturnType<typeof mapStateToProps> & {
  dispatch: Function,
  messages: any,
  onChooseBranch: Function,
  onGoBack: Function,
  secondChance: any,
  storylet: any,
};

export function SecondChance(props: Props) {
  const {
    dispatch,
    messages,
    onChooseBranch,
    onGoBack,
    privilegeLevel,
    secondChance,
    storylet,
  } = props;
  return (
    <Fragment>
      <StoryletRoot
        data={storylet}
        dispatch={dispatch}
        isChoosing={false}
        isGoingBack={false}
        privilegeLevel={privilegeLevel}
        shareData={storylet}
      />
      <SecondChanceComponent
        messages={messages}
        onChooseBranch={onChooseBranch}
        onGoBack={onGoBack}
        secondChance={secondChance}
        storylet={storylet}
      />
    </Fragment>
  );
}

const mapStateToProps = (state: IAppState) => ({
  privilegeLevel: state.user.privilegeLevel,
});

export default connect(mapStateToProps)(SecondChance);
